import * as React from 'react';
import { useEffect, useState } from 'react';
import { client } from '@/sanity/client';

export const HeaderDescription: React.FC = () => {
	const [description, setDescription] = useState('');

	useEffect(() => {
		const fetchDescription = async () => {
			const data = await client.fetch(
				`*[_type == "aboutPage"][0].header.subheading`,
			);
			setDescription(data);
		};

		fetchDescription();
	}, []);

	return (
		<p className='mt-6 text-3xl leading-10 max-md:max-w-full'>
			<span className='font-normal'>{description}</span>
		</p>
	);
};
